import { Icon } from "@shopify/polaris";
import {
	AddNoteMajor,
	AffiliateMajor,
	AppExtensionMinor,
	BillingStatementDollarMajor,
	ConnectMinor,
	KeyMajor,
	ManagedStoreMajor,
	PaymentsMajor,
	SettingsMinor,
	TapChipMajor,
	TransportMajor,
	DisputeMinor,
	DigitalMediaReceiverMajor,
} from "@shopify/polaris-icons";
import React, { useState, useCallback } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import config from "../../config/config";
const Tabs = (props) => {
	let history = useHistory();
	const dispatch = useDispatch();
	const dataSettings = useSelector((state) => state.dataSettings);
	const [tab, setTab] = useState(1);

	const changeTab = (tab) => {
		setTab(tab);
		props.changeTab(tab);
		history.push({
			pathname: config.pathName + "/settings",
			search: "?" + config.urlParamsValue,
		});
		if (config.checkLocalStorage) {
			localStorage.setItem("synctrack-setting-tab", tab);
		}
	};

	useEffect(() => {
		if (history.location.search.includes("stripe")) {
			setTab(2);
			props.changeTab(2);
		} else {
			if (config.checkLocalStorage) {
				if (localStorage.getItem("synctrack-setting-tab")) {
					setTab(
						parseInt(localStorage.getItem("synctrack-setting-tab"))
					);
					props.changeTab(
						parseInt(localStorage.getItem("synctrack-setting-tab"))
					);
				}
			}
		}
	}, [history.location.search]);

	return (
		<div className="w-100">
			<div
				className={
					tab === 1
						? "active settings-tab-layout"
						: "settings-tab-layout"
				}
				onClick={() => changeTab(1)}
			>
				<div className="d-inline-flex">
					<Icon color="white" source={PaymentsMajor} />
					<p className="ml-3">PayPal Settings</p>
				</div>
			</div>
			<div
				className={
					tab === 2
						? "active settings-tab-layout"
						: "settings-tab-layout"
				}
				onClick={() => changeTab(2)}
			>
				<div className="d-inline-flex">
					{" "}
					<Icon color="white" source={TapChipMajor} />
					<p className="ml-3">Stripe Settings</p>
				</div>
			</div>
			<div
				className={
					tab === 5
						? "active settings-tab-layout"
						: "settings-tab-layout"
				}
				onClick={() => changeTab(5)}
			>
				<div className="d-inline-flex">
					{" "}
					<Icon color="white" source={AffiliateMajor} />
					<p className="ml-3">Courier Mapping</p>
				</div>
			</div>
			<div
				className={
					tab === 3
						? "active settings-tab-layout"
						: "settings-tab-layout"
				}
				onClick={() => changeTab(3)}
			>
				<div className="d-inline-flex">
					{" "}
					<Icon color="white" source={ManagedStoreMajor} />
					<p className="ml-3">Multi Stores Integration</p>
				</div>
			</div>
			<div
				className={
					tab === 7
						? "active settings-tab-layout"
						: "settings-tab-layout"
				}
				onClick={() => changeTab(7)}
			>
				<div className="d-inline-flex">
					{" "}
					<Icon color="white" source={DigitalMediaReceiverMajor} />
					<p className="ml-3">Digital Product</p>
				</div>
			</div>
			{config.platform !== "WOO_COMMERCE" ? (
				<div
					className={
						tab === 6
							? "active settings-tab-layout"
							: "settings-tab-layout"
					}
					onClick={() => changeTab(6)}
				>
					<div className="d-inline-flex">
						{" "}
						<Icon color="white" source={AddNoteMajor} />
						<p className="ml-3">Shopify Order Notes</p>
					</div>
				</div>
			) : null}

			{config.platform !== "WOO_COMMERCE" ? (
				<div
					className={
						tab === 4
							? "active settings-tab-layout"
							: "settings-tab-layout"
					}
					onClick={() => changeTab(4)}
				>
					<div className="d-inline-flex">
						{" "}
						<Icon color="white" source={AppExtensionMinor} />
						<p className="ml-3">Integrations</p>
					</div>
				</div>
			) : null}
			{config.platform !== "WOO_COMMERCE" ? (
				<div
					className={
						tab === 8
							? "active settings-tab-layout"
							: "settings-tab-layout"
					}
					onClick={() => changeTab(8)}
				>
					<div className="d-inline-flex">
						{" "}
						<Icon color="white" source={DisputeMinor} />
						<p className="ml-3">Dispute Management</p>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default Tabs;
